<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">

      <div class="col-6 mt-3">
           <!-- Button trigger modal -->
<button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==4" type="button" class="btn btn-success" data-bs-toggle="modal" @click="addacademiccouncil()" data-bs-target="#exampleModal">
  <i class='bx bx-plus'></i>
</button>


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3 mt-3">
  
  <input type="text" class="form-control"   placeholder="ოქმის ნომერი" v-model="protocol_number">
 
</div>

<div class="mb-3">

  <input type="date" class="form-control" v-model="date"/>
</div>

<div class="mb-3">

<input type="text" class="form-control"  placeholder="საბჭოს მდივანი" v-model="secretary_council">
</div>
<div class="mb-3">

<input type="text" class="form-control"  placeholder="საბჭოს თავმჯდომარე" v-model="	chairman_board">
</div>


<div class="mb-3">

  <textarea rows="2" cols="50" name="agenda" form="usrform" class="form-control" placeholder=" დღის წესრიგი" v-model="agenda"></textarea>

</div>

<div class="mb-3">
  <textarea rows="2" cols="50" name="decisions" form="usrform" class="form-control" placeholder="გადაწყვეტილებები" v-model="decisions"></textarea>

</div>
<div class="mb-3">

<input type="file" class="form-control" @change="getacademiccouncilFile" >
</div>
        
      </div>
      <div class="modal-footer">
       
        <button v-if="!isReadyForEdit" type="button" class="btn btn-primary" @click="saveacademiccouncil()">შენახვა</button>
        <button v-else type="button" class="btn btn-success" @click="goEditacademiccouncil(academicCouncilID)">რედაქტირება</button>

      </div>
    </div>
  </div>
</div>
    
        </div>
             <div class="col-12 mt-3">
 

              <div class="row">
                  <div class="col-4 mb-2 d-grid" v-for="years of academicCouncilYears">
                    <button @click="showAcademicCouncil(years.academicCouncilYear)" class="btn btn-success">{{ years.academicCouncilYear }}</button>
                  </div>
              </div>


                 <table class="table" v-if="academiccouncils.length>0">
   <thead>
     <tr>
     
       <th class="col">ოქმის ნომერი</th>
       <th class="col">თარიღი</th>
       <th class="col">საბჭოს მდივანი</th>
       <th class="col">საბჭოს თავმჯდომარე</th>
       <th class="col">დღის წესრიგი</th>
       <th class="col">გადაწყვეტილებები</th>
       <th class="col">მიმაგრებული ფაილი</th>
 
     </tr>
   </thead>
   <tbody>
     
     <tr  v-for="academiccouncil in academiccouncils" :key="academiccouncil.academicCouncilID">
       
       <td scope="row">{{academiccouncil.protocol_number}}</td>
       <td> {{academiccouncil.date}}</td>
       <td>{{academiccouncil.secretary_council}}</td>
       <td>{{academiccouncil.chairman_board}}</td>
       <td>{{academiccouncil.agenda}}</td>
       <td>{{academiccouncil.decisions}}</td>
       <td> <a :href="'https://api.ugcollege.ug.edu.ge/storage/academiccouncil/'+academiccouncil.academiccouncil_file" target="_blank">მიმაგრებული ფაილი</a></td>
       <td><button v-if="this.$store.state.user.positionID==1" type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editCouncil(academiccouncil)"><i class='bx bxs-edit-alt'></i></button> </td>
       <td> <button v-if="this.$store.state.user.positionID==1" type="button" class="btn btn-outline-success" @click="deleteCouncil(academiccouncil.academicCouncilID)"><i class='bx bx-x'></i></button></td>
     </tr>
   
 
   </tbody>
 </table>
             </div>
 
     </div>
    </div>
  
 
 </template>
 <script>

import HttpRequests from '../httpRequests/httpRequests'
 const httpRequests= new HttpRequests()

 export default{
     
data(){
  return{
    protocol_number:null,
    date:null,
    secretary_council:null,
    chairman_board:null,
    agenda:null,
    decisions:null,
    academiccouncilFile: null,
    academiccouncils:[],
    isReadyForEdit:false,
    editcouncilID:0,
    academicCouncilYears:[]

  }
},

mounted(){


  httpRequests.getAcademicCouncilYears().then(response=>{
    this.academicCouncilYears=response.data
  })





},
 methods:{

  showAcademicCouncil(year){


    httpRequests.getAcademiccouncil(year).then(response=>{
    this.academiccouncils=response.data
})

  },  



  getacademiccouncilFile(e){
  this.academiccouncilFile=e.target.files[0]
 },

 saveacademiccouncil(){
        let formData=new FormData()

        formData.append('protocol_number',this.protocol_number)
        formData.append('date',this.date)
        formData.append('secretary_council',this.secretary_council)
        formData.append('chairman_board',this.chairman_board)
        formData.append('agenda',this.agenda)
        formData.append('decisions',this.decisions)
        formData.append('academiccouncilFile',this.academiccouncilFile)

        httpRequests.saveacademiccouncil(formData).then(()=>{
          location.reload()
        })
        
      },
      editCouncil(Council){
        this.isReadyForEdit=true
        this.academicCouncilID=Council.academicCouncilID
        this.protocol_number=Council.protocol_number
        this.date=Council.date
        this.secretary_council=Council.secretary_council
        this.chairman_board=Council.chairman_board
        this.agenda=Council.agenda
        this.decisions=Council.decisions
        this.academiccouncil_file=Council.academiccouncil_file
 
},

addacademiccouncil(){
        this.isReadyForEdit=false
        this.academicCouncilID=0
        this.protocol_number=null
        this.date=null
        this.secretary_council=null
        this.chairman_board=null
        this.agenda=null
        this.decisions=null
        this.academiccouncil_file=null
      },

      goEditacademiccouncil(academicCouncilID){

let formData=new FormData()

formData.append('protocol_number',this.protocol_number)
        formData.append('date',this.date)
        formData.append('secretary_council',this.secretary_council)
        formData.append('chairman_board',this.chairman_board)
        formData.append('agenda',this.agenda)
        formData.append('decisions',this.decisions)
        formData.append('academiccouncilFile',this.academiccouncilFile)
        formData.append('academicCouncilID',academicCouncilID)

  httpRequests.goEditacademiccouncil(formData).then(()=>{
    location.reload()
  })

    
      },

      deleteCouncil(academicCouncilID){

if(confirm("ნამდვილად გსურთ წაშლა?")){
  httpRequests.deleteCouncil(academicCouncilID).then(()=>{
    location.reload()
  })
}

}

    }
 }

</script>